// extracted by mini-css-extract-plugin
export default {"rating":"vD-z","numberOfStars":"wD-z","count":"xD-z","barGraphSpacing":"yD-z","barGraph":"zD-z"};